export const getRouterBasename = (): string | undefined => {
    const prefix = window.__CONFIG__?.REACT_APP_SERVE_ROUTE_PREFIX;

    if (prefix === '/') {
        return undefined;
    }

    if (prefix) {
        return prefix;
    }

    return '/admin';
};
